export const imgHr1 = {
    src: 'images/hr.png'
};

// export const imgHr2 = {
//     src: 'images/hr-top.png',
//     alt: '',
//     text: ''
// };